webpackJsonp([62],{

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i18n", function() { return i18n; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_i18n__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_translations__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_filters__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_filters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_filters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fastclick__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_touch__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loglevel_plugin_prefix__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_loglevel_plugin_prefix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_loglevel_plugin_prefix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_kronolog_client__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_detector__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_detector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_detector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_shared_audio_player_vue__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_shared_audio_player_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_shared_audio_player_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_awesome_components_Icon_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_awesome_components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_awesome_components_Icon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_awesome_icons_volume_up__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_awesome_icons_arrow_right__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_awesome_icons_arrow_left__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_awesome_icons_arrow_down__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_awesome_icons_volume_off__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_awesome_icons_check_circle__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_awesome_icons_times_circle__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_awesome_icons_question_circle__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__lib_logger__ = __webpack_require__(57);
















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('audio-player', __WEBPACK_IMPORTED_MODULE_12__components_shared_audio_player_vue___default.a);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('icon', __WEBPACK_IMPORTED_MODULE_13_vue_awesome_components_Icon_vue___default.a);











window.$ = window.jQuery = __webpack_require__(500);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue2_filters___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

function browserInfo() {
    var uniwin = {
        width: window.innerWidth || document.documentElement.clientWidth || document.body.offsetWidth,
        height: window.innerHeight || document.documentElement.clientHeight || document.body.offsetHeight
    };
    __WEBPACK_IMPORTED_MODULE_11_detector___default.a.scrrenWidth = screen.width;
    __WEBPACK_IMPORTED_MODULE_11_detector___default.a.scrrenHeight = screen.height;
    __WEBPACK_IMPORTED_MODULE_11_detector___default.a.colorDepth = screen.colorDepth;
    __WEBPACK_IMPORTED_MODULE_11_detector___default.a.browserWidth = uniwin.width;
    __WEBPACK_IMPORTED_MODULE_11_detector___default.a.browserHeight = uniwin.height;
    return __WEBPACK_IMPORTED_MODULE_11_detector___default.a;
}

function authenticated(to) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_kronolog_client__["a" /* currentUserInfo */])().then(function (response) {
        __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].debug('Logged in');
        var tasks = ['srt', 'crt', 'dsb', 'dsf', 'vm', 'vismem', 'mst', 'pst', 'cod'];
        var isTask = tasks.indexOf(to.path.substr(1));

        if (isTask >= 0) {
            __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].debug('[Router] Got a task navigation request');
            if (__WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].state.user.consent_given_at === null) {
                __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].warn('[Router] Task navigation request REJECTED: No consent');
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace('/dash');
                return null;
            }

            if (to.path.substr(1) !== __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters.currentTask) {
                __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].warn('[Router] Task navigation request REJECTED: No not matching state (' + __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].getters.currentTask + ')');
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace('/dash');
                return null;
            }
        }
    }, function (error) {
        __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].debug(error);
        __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].info('Not logged in');
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace('/');
        return null;
    });
}

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
    if (__WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].state.project.id == null) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_kronolog_client__["b" /* projectInfo */])().then(function (result) {
            __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('SET_PROJECT', result.data);
        }).catch(function (e) {
            __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].debug(e);
        });
    }

    if (to.params.userID && to.params.projectID) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_kronolog_client__["c" /* authenticate */])(to.params.userID, to.params.userID, to.params.projectID).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].debug(response);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_kronolog_client__["a" /* currentUserInfo */])().then(function (response) {
                window.dirty = true;

                var prefixDefaults = {
                    template: to.params.userID + '>>[%t]',
                    timestampFormatter: function timestampFormatter(date) {
                        return date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1');
                    },
                    levelFormatter: function levelFormatter(level) {
                        return level.toUpperCase();
                    },
                    nameFormatter: function nameFormatter(name) {
                        return name || 'root';
                    }
                };
                __WEBPACK_IMPORTED_MODULE_9_loglevel_plugin_prefix___default.a.apply(__WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */], prefixDefaults);
                var temp = response.data;
                temp.userId = to.params.userID;
                var userInfo = temp;
                __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].info('Setting current user to: %o', userInfo);
                __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('SET_USER', userInfo);

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_kronolog_client__["d" /* getTasks */])().then(function (result) {
                    __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('SET_TASKSTATE', result.data.tasks);
                    __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].debug(result);
                }, function (error) {
                    __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].error(error);
                    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace('/error');
                });
            }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].error('Unable to fetch current user', error);
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace('/link');
            });

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_kronolog_client__["e" /* createSession */])(browserInfo()).then(function (response) {
                if (__WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].state.user.consent_given_at !== null) {
                    var consent = {
                        status: true,
                        timestamp: __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].state.user.consent_given_at,
                        upload: null,
                        completed: true
                    };
                    if (__WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].state.user.wants_result_summary) {
                        __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('SET_CONSENT', consent);

                        __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('SET_CURRENTCONTEXT', 'resultsummary');
                        __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].info('User consent given, user wants feedback, moving on');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('SET_CONSENT', consent);

                        __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('SET_CURRENTCONTEXT', 'audiocheck');
                        __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].info('User consent given, moving on');
                    }
                }
            }, function (error) {
                __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].error('Unable to create session', error);
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace('/error');
            });
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace('/dash');
        }, function (error) {
            __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].debug(error);
            __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].debug('Direct login failed, try manual login');

            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace('/link');
        });
    } else if (to.params.token) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_kronolog_client__["f" /* authenticateWithToken */])(to.params.token).then(function (response) {
            __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].debug(response);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_kronolog_client__["a" /* currentUserInfo */])().then(function (response) {
                window.dirty = true;

                var prefixDefaults = {
                    template: to.params.userID + '>>[%t]',
                    timestampFormatter: function timestampFormatter(date) {
                        return date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1');
                    },
                    levelFormatter: function levelFormatter(level) {
                        return level.toUpperCase();
                    },
                    nameFormatter: function nameFormatter(name) {
                        return name || 'root';
                    }
                };
                __WEBPACK_IMPORTED_MODULE_9_loglevel_plugin_prefix___default.a.apply(__WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */], prefixDefaults);
                var temp = response.data;
                temp.userId = to.params.userID;
                var userInfo = temp;
                __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].info('Setting current user to: %o', userInfo);
                __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('SET_USER', userInfo);

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_kronolog_client__["d" /* getTasks */])().then(function (result) {
                    __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('SET_TASKSTATE', result.data.tasks);
                    __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].debug(result);
                }, function (error) {
                    __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].error(error);
                    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace('/error');
                });
            }).catch(function (error) {
                __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].error('Unable to fetch current user', error);
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace('/link');
            });

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib_kronolog_client__["e" /* createSession */])(browserInfo()).then(function (response) {
                if (__WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].state.user.consent_given_at !== null) {
                    var consent = {
                        status: true,
                        timestamp: __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].state.user.consent_given_at,
                        upload: null,
                        completed: true
                    };
                    if (__WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].state.user.wants_result_summary) {
                        __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('SET_CONSENT', consent);

                        __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('SET_CURRENTCONTEXT', 'resultsummary');
                        __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].info('User consent given, user wants feedback, moving on');
                    } else {
                        __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('SET_CONSENT', consent);

                        __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */].commit('SET_CURRENTCONTEXT', 'questions');
                        __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].info('User consent given, moving on');
                    }
                }
            }, function (error) {
                __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].error('Unable to create session', error);
                __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace('/error');
            });
            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace('/dash');
        }, function (error) {
            __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].debug(error);
            __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].debug('Direct login failed, try manual login');

            __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace('/link');
        });
    } else {
        authenticated(to);
    }

    __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].debug('[Router] *NAV* From: ' + from.path + ' To: ' + to.path);
    next();
});

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].afterEach(function (to, from, next) {
    __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].info('[Router] Navigated from: ' + from.path + ' to: ' + to.path);
});

var i18n = new __WEBPACK_IMPORTED_MODULE_4_vue_i18n__["a" /* default */]({
    locale: 'no',
    messages: __WEBPACK_IMPORTED_MODULE_5__data_translations__["a" /* default */],
    silentTranslationWarn: true
});



var vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_3__store_store__["a" /* default */],
    i18n: i18n,
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

__WEBPACK_IMPORTED_MODULE_7_fastclick__["attach"](document.body);

window.onbeforeunload = function () {
    __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].info('User may have closed tab.');
    if (window.dirty) {
        return 'Are you sure you want to navigate away?';
    }
};
window.unload = function () {
    __WEBPACK_IMPORTED_MODULE_22__lib_logger__["a" /* default */].debug('Leaved page...');
};

/***/ }),

/***/ 202:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = projectInfo;
/* harmony export (immutable) */ __webpack_exports__["c"] = authenticate;
/* harmony export (immutable) */ __webpack_exports__["f"] = authenticateWithToken;
/* harmony export (immutable) */ __webpack_exports__["k"] = logout;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSession;
/* harmony export (immutable) */ __webpack_exports__["a"] = currentUserInfo;
/* harmony export (immutable) */ __webpack_exports__["d"] = getTasks;
/* harmony export (immutable) */ __webpack_exports__["j"] = getWordList;
/* harmony export (immutable) */ __webpack_exports__["p"] = userConsentGiven;
/* harmony export (immutable) */ __webpack_exports__["m"] = userWasDisturbedOnTasks;
/* harmony export (immutable) */ __webpack_exports__["l"] = userWantsResultSummary;
/* unused harmony export userBirthyearSexEducation */
/* harmony export (immutable) */ __webpack_exports__["o"] = userHasRetakenTasks;
/* harmony export (immutable) */ __webpack_exports__["h"] = createResult;
/* harmony export (immutable) */ __webpack_exports__["g"] = updateResult;
/* harmony export (immutable) */ __webpack_exports__["n"] = generatePDF;
/* harmony export (immutable) */ __webpack_exports__["i"] = getSurvey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios_retry__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios_retry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios_retry__);





var httpClient = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
    baseURL: "api.hukommelseweb.no",
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
});

__WEBPACK_IMPORTED_MODULE_3_axios_retry___default()(httpClient, { retries: 3 });

function projectInfo() {
    var url = location.host;
    return httpClient.get('projects/', { params: { domain: url } });
}

function authenticate(username, password, projectID) {
    var requestPromise = httpClient.post('user_tokens', {
        auth: {
            username: username,
            password: password,
            project_id: projectID
        }
    });

    requestPromise.then(function (response) {
        httpClient.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.jwt;
    }).catch(function (e) {
        __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].error(e);
    });

    return requestPromise;
}

function authenticateWithToken(token) {
    var requestPromise = httpClient.post('link_tokens', {
        token: token
    });

    requestPromise.then(function (response) {
        httpClient.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.jwt;
    }).catch(function (e) {
        __WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */].error(e);
    });

    return requestPromise;
}

function logout() {
    httpClient.defaults.headers.common['Authorization'] = '';
}

function createSession(browserInfo) {
    return httpClient.post('sessions', { session_data: { browser_info: browserInfo } });
}

function currentUserInfo() {
    return httpClient.get('users/current');
}

function getTasks() {
    return httpClient.get('tasks');
}

function getWordList() {
    return httpClient.get('users/current/word_list');
}

function userConsentGiven(birthyear, sex, education, handedness, computerFamiliarity) {
    return httpClient.patch('users/current', {
        consent_given_at: new Date(),
        birthyear: birthyear,
        sex: sex,
        education: education,
        handedness: handedness,
        computer_familiarity: computerFamiliarity
    });
}

function userWasDisturbedOnTasks(tasks) {
    return httpClient.patch('users/current', { feedback: { disturbed_on_tasks: tasks } });
}

function userWantsResultSummary() {
    return httpClient.patch('users/current', { wants_result_summary: true });
}

function userBirthyearSexEducation(birthyear, sex, education) {
    return httpClient.patch('users/current', { birthyear: birthyear, sex: sex, education: education });
}

function userHasRetakenTasks() {
    return httpClient.patch('users/current', { retaken_tasks: true });
}

function createResult(data) {
    return httpClient.post('results', { result: data });
}

function updateResult(resultID, resultData) {
    return httpClient.patch('results/' + resultID, { result: resultData });
}

function generatePDF() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        httpClient.get('pdf', { 'responseType': 'blob' }).then(function (response) {
            var b = new Blob([response.data], { type: 'application/pdf' });
            var url = window.URL.createObjectURL(b);
            var link = document.createElement('a');
            link.href = url;
            link.download = 'scores.pdf';
            document.body.appendChild(link);
            link.click();
            link.remove();
            resolve();
        }).catch(function (error) {
            reject(error);
        });
    });
}

function getSurvey(taskId) {
    return httpClient.get('survey/' + taskId);
}

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(94)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(519),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(520);



var Dashboard = function Dashboard(resolve) {
    __webpack_require__.e/* require.ensure */(22).then((function () {
        resolve(__webpack_require__(528), 'dash');
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Completed = function Completed(resolve) {
    __webpack_require__.e/* require.ensure */(55).then((function () {
        resolve(__webpack_require__(587), 'shared');
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Error = function Error(resolve) {
    __webpack_require__.e/* require.ensure */(60).then((function () {
        resolve(__webpack_require__(529), 'error');
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Aborted = function Aborted(resolve) {
    __webpack_require__.e/* require.ensure */(56).then((function () {
        resolve(__webpack_require__(527), 'shared');
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var DigitSpanForwards = function DigitSpanForwards(resolve) {
    __webpack_require__.e/* require.ensure */(18).then((function () {
        resolve(__webpack_require__(551));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var DigitSpanBackwards = function DigitSpanBackwards(resolve) {
    __webpack_require__.e/* require.ensure */(19).then((function () {
        resolve(__webpack_require__(550));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var Coding = function Coding(resolve) {
    __webpack_require__.e/* require.ensure */(10).then((function () {
        resolve(__webpack_require__(541));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PatternSeparationTask = function PatternSeparationTask(resolve) {
    __webpack_require__.e/* require.ensure */(5).then((function () {
        resolve(__webpack_require__(559));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SimpleReactionTime = function SimpleReactionTime(resolve) {
    __webpack_require__.e/* require.ensure */(25).then((function () {
        resolve(__webpack_require__(572));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var SimpleReactionTimeAudio = function SimpleReactionTimeAudio(resolve) {
    __webpack_require__.e/* require.ensure */(24).then((function () {
        resolve(__webpack_require__(573));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ComplexReactionTime = function ComplexReactionTime(resolve) {
    __webpack_require__.e/* require.ensure */(35).then((function () {
        resolve(__webpack_require__(542));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var VerbalMemory = function VerbalMemory(resolve) {
    __webpack_require__.e/* require.ensure */(0).then((function () {
        resolve(__webpack_require__(581));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var VisualMemory = function VisualMemory(resolve) {
    __webpack_require__.e/* require.ensure */(2).then((function () {
        resolve(__webpack_require__(582));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var MST = function MST(resolve) {
    __webpack_require__.e/* require.ensure */(23).then((function () {
        resolve(__webpack_require__(557));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ANT = function ANT(resolve) {
    __webpack_require__.e/* require.ensure */(9).then((function () {
        resolve(__webpack_require__(534));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var PictureVocabularyTask = function PictureVocabularyTask(resolve) {
    __webpack_require__.e/* require.ensure */(34).then((function () {
        resolve(__webpack_require__(562));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var iqtest = function iqtest(resolve) {
    __webpack_require__.e/* require.ensure */(28).then((function () {
        resolve(__webpack_require__(584));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var PatternRecognitionTest = function PatternRecognitionTest(resolve) {
    __webpack_require__.e/* require.ensure */(6).then((function () {
        resolve(__webpack_require__(586));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var HADS = function HADS(resolve) {
    __webpack_require__.e/* require.ensure */(44).then((function () {
        resolve(__webpack_require__(555));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var ASRS = function ASRS(resolve) {
    __webpack_require__.e/* require.ensure */(51).then((function () {
        resolve(__webpack_require__(535));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var UPPSP = function UPPSP(resolve) {
    __webpack_require__.e/* require.ensure */(41).then((function () {
        resolve(__webpack_require__(580));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var RUSSUG = function RUSSUG(resolve) {
    __webpack_require__.e/* require.ensure */(29).then((function () {
        resolve(__webpack_require__(570));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var AUDIT = function AUDIT(resolve) {
    __webpack_require__.e/* require.ensure */(50).then((function () {
        resolve(__webpack_require__(536));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var DUDIT = function DUDIT(resolve) {
    __webpack_require__.e/* require.ensure */(46).then((function () {
        resolve(__webpack_require__(549));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var COBRA = function COBRA(resolve) {
    __webpack_require__.e/* require.ensure */(49).then((function () {
        resolve(__webpack_require__(539));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var CPFSurvey = function CPFSurvey(resolve) {
    __webpack_require__.e/* require.ensure */(48).then((function () {
        resolve(__webpack_require__(540));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var BWSurvey = function BWSurvey(resolve) {
    __webpack_require__.e/* require.ensure */(53).then((function () {
        resolve(__webpack_require__(537));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var RAND36 = function RAND36(resolve) {
    __webpack_require__.e/* require.ensure */(42).then((function () {
        resolve(__webpack_require__(567));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var shortpersonalitytest = function shortpersonalitytest(resolve) {
    __webpack_require__.e/* require.ensure */(39).then((function () {
        resolve(__webpack_require__(561));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var personalitytest = function personalitytest(resolve) {
    __webpack_require__.e/* require.ensure */(40).then((function () {
        resolve(__webpack_require__(560));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var GRIT = function GRIT(resolve) {
    __webpack_require__.e/* require.ensure */(45).then((function () {
        resolve(__webpack_require__(554));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var rewardandpunishment = function rewardandpunishment(resolve) {
    __webpack_require__.e/* require.ensure */(36).then((function () {
        resolve(__webpack_require__(571));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var rrq = function rrq(resolve) {
    __webpack_require__.e/* require.ensure */(38).then((function () {
        resolve(__webpack_require__(568));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var rrs = function rrs(resolve) {
    __webpack_require__.e/* require.ensure */(37).then((function () {
        resolve(__webpack_require__(569));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var pretest = function pretest(resolve) {
    __webpack_require__.e/* require.ensure */(31).then((function () {
        resolve(__webpack_require__(565));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var posttest = function posttest(resolve) {
    __webpack_require__.e/* require.ensure */(33).then((function () {
        resolve(__webpack_require__(563));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var pretestfatigue = function pretestfatigue(resolve) {
    __webpack_require__.e/* require.ensure */(30).then((function () {
        resolve(__webpack_require__(566));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var posttestfatigue = function posttestfatigue(resolve) {
    __webpack_require__.e/* require.ensure */(32).then((function () {
        resolve(__webpack_require__(564));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Breakpoint = function Breakpoint(resolve) {
    __webpack_require__.e/* require.ensure */(54).then((function () {
        resolve(__webpack_require__(538));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Matrix = function Matrix(resolve) {
    __webpack_require__.e/* require.ensure */(27).then((function () {
        resolve(__webpack_require__(585));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var AddiQoL = function AddiQoL(resolve) {
    __webpack_require__.e/* require.ensure */(52).then((function () {
        resolve(__webpack_require__(533));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var fingertappingtest = function fingertappingtest(resolve) {
    __webpack_require__.e/* require.ensure */(13).then((function () {
        resolve(__webpack_require__(553));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};


var Login = function Login(resolve) {
    __webpack_require__.e/* require.ensure */(57).then((function () {
        resolve(__webpack_require__(532));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var CPT = function CPT(resolve) {
    __webpack_require__.e/* require.ensure */(20).then((function () {
        resolve(__webpack_require__(543));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Stroop = function Stroop(resolve) {
    __webpack_require__.e/* require.ensure */(12).then((function () {
        resolve(__webpack_require__(574));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var StroopEmotional = function StroopEmotional(resolve) {
    __webpack_require__.e/* require.ensure */(11).then((function () {
        resolve(__webpack_require__(575));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var CPTMS = function CPTMS(resolve) {
    __webpack_require__.e/* require.ensure */(14).then((function () {
        resolve(__webpack_require__(547));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var CPT10 = function CPT10(resolve) {
    __webpack_require__.e/* require.ensure */(15).then((function () {
        resolve(__webpack_require__(544));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var CPTAUDIO = function CPTAUDIO(resolve) {
    __webpack_require__.e/* require.ensure */(26).then((function () {
        resolve(__webpack_require__(545));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var CPTAUDIO7 = function CPTAUDIO7(resolve) {
    __webpack_require__.e/* require.ensure */(17).then((function () {
        resolve(__webpack_require__(546));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var SYNSOPPFATNINGBLOKK = function SYNSOPPFATNINGBLOKK(resolve) {
    __webpack_require__.e/* require.ensure */(8).then((function () {
        resolve(__webpack_require__(577));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var SYNSOPPFATNINGBLOKKMULTI = function SYNSOPPFATNINGBLOKKMULTI(resolve) {
    __webpack_require__.e/* require.ensure */(7).then((function () {
        resolve(__webpack_require__(578));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var SYNSOPPFATNINGEVENT = function SYNSOPPFATNINGEVENT(resolve) {
    __webpack_require__.e/* require.ensure */(3).then((function () {
        resolve(__webpack_require__(579));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var LinkLogin = function LinkLogin(resolve) {
    __webpack_require__.e/* require.ensure */(59).then((function () {
        resolve(__webpack_require__(530));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var LinkTokenLogin = function LinkTokenLogin(resolve) {
    __webpack_require__.e/* require.ensure */(58).then((function () {
        resolve(__webpack_require__(531));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var PSST = function PSST(resolve) {
    __webpack_require__.e/* require.ensure */(43).then((function () {
        resolve(__webpack_require__(558));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var DERS = function DERS(resolve) {
    __webpack_require__.e/* require.ensure */(47).then((function () {
        resolve(__webpack_require__(548));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var Survey = function Survey(resolve) {
    __webpack_require__.e/* require.ensure */(21).then((function () {
        resolve(__webpack_require__(576));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var MRT = function MRT(resolve) {
    __webpack_require__.e/* require.ensure */(16).then((function () {
        resolve(__webpack_require__(556));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var VisualPerception = function VisualPerception(resolve) {
    __webpack_require__.e/* require.ensure */(4).then((function () {
        resolve(__webpack_require__(583));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var DotProbe = function DotProbe(resolve) {
    __webpack_require__.e/* require.ensure */(1).then((function () {
        resolve(__webpack_require__(552));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    routes: [{
        path: '*',
        name: 'error',
        component: Error
    }, {
        path: '/',
        name: 'index',
        component: Login
    }, {
        path: '/auth/:projectID/:userID',
        name: 'lmi',
        component: LinkLogin
    }, {
        path: '/link/:token',
        name: 'lmi2',
        component: LinkTokenLogin
    }, {
        path: '/login',
        name: 'login',
        component: Login
    }, {
        path: '/error',
        name: 'error',
        component: Error
    }, {
        path: '/dash',
        name: 'dashboard',
        component: Dashboard
    }, {
        path: '/dsf',
        name: 'DigitSpanForwards',
        component: DigitSpanForwards
    }, {
        path: '/dsb',
        name: 'DigitSpanBackwards',
        component: DigitSpanBackwards
    }, {
        path: '/cod',
        name: 'Coding',
        component: Coding
    }, {
        path: '/srt',
        name: 'SimpleReactionTime',
        component: SimpleReactionTime
    }, {
        path: '/srtaudio',
        name: 'SimpleReactionTimeAudio',
        component: SimpleReactionTimeAudio
    }, {
        path: '/crt',
        name: 'ComplexReactionTime',
        component: ComplexReactionTime
    }, {
        path: '/pst',
        name: 'PatternSeparationTask',
        component: PatternSeparationTask
    }, {
        path: '/mst',
        name: 'MST',
        component: MST
    }, {
        path: '/ant',
        name: 'ant',
        component: ANT
    }, {
        path: '/vm',
        name: 'VerbalMemory',
        component: VerbalMemory
    }, {
        path: '/vismem',
        name: 'VisualMemory',
        component: VisualMemory
    }, {
        path: '/aborted',
        name: 'Aborted',
        component: Aborted
    }, {
        path: '/completed',
        name: 'completed',
        component: Completed
    }, {
        path: '/pvt',
        name: 'pictureVocabulary',
        component: PictureVocabularyTask
    }, {
        path: '/matrix',
        name: 'MatrixTest',
        component: Matrix
    }, {
        path: '/mat',
        name: 'MatrixTestIQT',
        component: iqtest
    }, {
        path: '/ptr',
        name: 'PatternRecognition',
        component: PatternRecognitionTest
    }, {
        path: '/hads',
        name: 'hads',
        component: HADS
    }, {
        path: '/asrs',
        name: 'asrs',
        component: ASRS
    }, {
        path: '/uppsp',
        name: 'uppsp',
        component: UPPSP
    }, {
        path: '/russug',
        name: 'russug',
        component: RUSSUG
    }, {
        path: '/audit',
        name: 'audit',
        component: AUDIT
    }, {
        path: '/dudit',
        name: 'dudit',
        component: DUDIT
    }, {
        path: '/cobra',
        name: 'cobra',
        component: COBRA
    }, {
        path: '/cpfsurvey',
        name: 'cpfsurvey',
        component: CPFSurvey
    }, {
        path: '/birthweightsurvey',
        name: 'birthweightsurvey',
        component: BWSurvey
    }, {
        path: '/grit',
        name: 'grit',
        component: GRIT
    }, {
        path: '/rand36',
        name: 'rand36',
        component: RAND36
    }, {
        path: '/shortpersonalitytest',
        name: 'shortpersonalitytest',
        component: shortpersonalitytest
    }, {
        path: '/personalitytest',
        name: 'personalitytest',
        component: personalitytest
    }, {
        path: '/rewardandpunishment',
        name: 'rewardandpunishment',
        component: rewardandpunishment
    }, {
        path: '/rrq',
        name: 'rrq',
        component: rrq
    }, {
        path: '/rrs',
        name: 'rrs',
        component: rrs
    }, {
        path: '/addiqol',
        name: 'addiqol',
        component: AddiQoL
    }, {
        path: '/pretest',
        name: 'pretest',
        component: pretest
    }, {
        path: '/posttest',
        name: 'posttest',
        component: posttest
    }, {
        path: '/pretestfatigue',
        name: 'pretestfatigue',
        component: pretestfatigue
    }, {
        path: '/posttestfatigue',
        name: 'posttestfatigue',
        component: posttestfatigue
    }, {
        path: '/breakpoint',
        name: 'breakpoint',
        component: Breakpoint
    }, {
        path: '/cpt',
        name: 'cpt',
        component: CPT
    }, {
        path: '/stroop',
        name: 'stroop',
        component: Stroop
    }, {
        path: '/stroope',
        name: 'stroope',
        component: StroopEmotional
    }, {
        path: '/cptms',
        name: 'cptms',
        component: CPTMS
    }, {
        path: '/cpt10',
        name: 'cpt10',
        component: CPT10
    }, {
        path: '/cptaudio',
        name: 'cptaudio',
        component: CPTAUDIO
    }, {
        path: '/cptaudio7',
        name: 'cptaudio7',
        component: CPTAUDIO7
    }, {
        path: '/fingertappingtest',
        name: 'fingertappingtest',
        component: fingertappingtest
    }, {
        path: '/synsoppfatningBlokk',
        name: 'synsoppfatningBlokk',
        component: SYNSOPPFATNINGBLOKK
    }, {
        path: '/synsoppfatningBlokkMulti',
        name: 'synsoppfatningBlokkMulti',
        component: SYNSOPPFATNINGBLOKKMULTI
    }, {
        path: '/synsoppfatningEvent',
        name: 'synsoppfatningEvent',
        component: SYNSOPPFATNINGEVENT
    }, {
        path: '/psst',
        name: 'psst',
        component: PSST
    }, {
        path: '/ders',
        name: 'ders',
        component: DERS
    }, {
        path: '/survey',
        name: 'survey',
        component: Survey
    }, {
        path: '/mrt',
        name: 'mrt',
        component: MRT
    }, {
        path: '/visualPerception',
        name: 'visualPerception',
        component: VisualPerception
    }, {
        path: '/dotProbe',
        name: 'dotProbe',
        component: DotProbe
    }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_howler__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_howler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_howler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_clamp__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_clamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_clamp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_values__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_values__);





/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        sources: {
            type: Array,
            required: false,
            validator: function validator(sources) {
                return sources.every(function (source) {
                    return typeof source === 'string' && source.length > 0;
                });
            }
        },

        autoplay: {
            type: Boolean,
            default: true
        },

        loop: {
            type: Boolean,
            default: false
        },

        preload: {
            type: Boolean,
            default: true
        },

        html5: {
            type: Boolean,
            default: false
        },
        myname: {
            type: String,
            default: ''
        }
    },

    data: function data() {
        var _this = this;

        return {
            _howl: null,

            playing: false,

            muted: false,

            volume: 1.0,

            rate: 1.0,

            seek: 0,

            duration: 0,

            _polls: {
                seek: {
                    id: null,
                    interval: 1000 / 4,
                    hook: function hook() {
                        _this.seek = _this.$data._howl.seek();
                    }
                }
            },

            _howlEvents: [{
                name: 'load',
                hook: function hook() {
                    _this.duration = _this.$data._howl.duration();
                }
            }, 'loaderror', {
                name: 'play',
                hook: function hook() {
                    _this.playing = true;
                }
            }, {
                name: 'end',
                hook: function hook() {
                    _this.playing = false;
                }
            }, {
                name: 'pause',
                hook: function hook() {
                    _this.playing = false;
                }
            }, {
                name: 'stop',
                hook: function hook() {
                    _this.playing = false;
                    if (_this.$data._howl != null) {
                        _this.seek = _this.$data._howl.seek();
                    }
                }
            }, 'mute', {
                name: 'volume',
                hook: function hook() {
                    _this.volume = _this.$data._howl.volume();
                }
            }, {
                name: 'rate',
                hook: function hook() {
                    _this.rate = _this.$data._howl.rate();
                }
            }, {
                name: 'seek',
                hook: function hook() {
                    _this.seek = _this.$data._howl.seek();
                }
            }, 'fade']
        };
    },


    computed: {
        progress: function progress() {
            if (this.duration === 0) return 0;
            return this.seek / this.duration;
        }
    },

    created: function created() {
        var _this2 = this;

        this.$data._howl = new __WEBPACK_IMPORTED_MODULE_1_howler__["Howl"]({
            src: this.sources,
            volume: this.volume,
            autoplay: this.autoplay,
            loop: this.loop,
            preload: this.preload,
            html5: this.html5,
            myname: this.myname
        });

        var duration = this.$data._howl.duration();
        this.duration = duration;

        if (duration > 0) {
            this.$parent.$emit('load');
        }

        this.$data._howlEvents = this.$data._howlEvents.map(function (event) {
            if (typeof event === 'string') {
                event = { name: event };
            }

            var handler = function handler(id, details) {
                if (typeof event.hook === 'function') event.hook(id, details);
                _this2.$parent.$emit(event.name, _this2.myname, details);
            };

            _this2.$data._howl.on(event.name, handler);

            return { name: event.name, handler: handler };
        });
    },
    beforeDestroy: function beforeDestroy() {
        var _this3 = this;

        this.stop();

        __WEBPACK_IMPORTED_MODULE_3_lodash_values___default()(this.$data._polls).forEach(function (poll) {
            if (poll.id != null) clearInterval(poll.id);
        });

        this.$data._howlEvents.forEach(function (_ref) {
            var name = _ref.name,
                handler = _ref.handler;
            return _this3.$data._howl.off(name, handler);
        });

        this.$data._howl = null;
    },


    watch: {
        playing: function playing(_playing) {
            this.seek = this.$data._howl.seek();

            if (_playing) {
                this.$data._polls.seek.id = setInterval(this.$data._polls.seek.hook, this.$data._polls.seek.interval);
            } else {
                clearInterval(this.$data._polls.seek.id);
            }
        }
    },

    methods: {
        play: function play() {
            if (!this.playing) this.$data._howl.play();
        },
        pause: function pause() {
            if (this.playing) this.$data._howl.pause();
        },
        togglePlayback: function togglePlayback() {
            if (!this.playing) {
                this.$data._howl.play();
            } else {
                this.$data._howl.pause();
            }
        },
        stop: function stop() {
            this.$data._howl.stop();
        },
        mute: function mute() {
            this.$data._howl.mute(true);
            this.muted = true;
        },
        unmute: function unmute() {
            this.$data._howl.mute(false);
            this.muted = false;
        },
        toggleMute: function toggleMute() {
            this.$data._howl.mute(!this.muted);
            this.muted = !this.muted;
        },
        setVolume: function setVolume(volume) {
            if (typeof volume !== 'number') {
                throw new Error('volume must be a number, got a ' + (typeof volume === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(volume)) + ' instead');
            }

            this.$data._howl.volume(__WEBPACK_IMPORTED_MODULE_2_lodash_clamp___default()(volume, 0, 1));
        },
        setRate: function setRate(rate) {
            if (typeof rate !== 'number') {
                throw new Error('rate must be a number, got a ' + (typeof rate === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(rate)) + ' instead');
            }

            this.$data._howl.rate(__WEBPACK_IMPORTED_MODULE_2_lodash_clamp___default()(rate, 0.5, 4));
        },
        setSeek: function setSeek(seek) {
            if (typeof seek !== 'number') {
                throw new Error('seek must be a number, got a ' + (typeof seek === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(seek)) + ' instead');
            }

            this.$data._howl.seek(__WEBPACK_IMPORTED_MODULE_2_lodash_clamp___default()(seek, 0, this.duration));
        },
        setProgress: function setProgress(progress) {
            if (typeof progress !== 'number') {
                throw new Error('progress must be a number, got a ' + (typeof progress === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(progress)) + ' instead');
            }

            this.setSeek(__WEBPACK_IMPORTED_MODULE_2_lodash_clamp___default()(progress, 0, 1) * this.duration);
        }
    }
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    en: {
        message: {
            yes: 'yes',
            no: 'no',
            hello: 'hello world',
            instruction: 'instructions',
            practiceAborted: 'Practice aborted',
            completed: 'Completed',
            practice: 'Practice',
            test: 'Main task',
            continue: 'Continue',
            pressContinuePractice: 'Press continue to start the practice round.',
            pressContinueTest: 'Press continue to start.',
            abort: 'Exit task',
            retryTitle: 'Another round of practice',
            retryText: 'To ensure that you understand the task, the practice continues with a few more exercises.',
            trainingCompleted: 'Training completed!',
            trainingCompletedInfo: 'Press continue to start the main task',
            noFeedback: 'You will not get feedback on your responses.',
            feedback: 'You will get feedback on the screen if you do it correctly or not.',
            recall: 'Recall',
            delayed: 'Delayed recall',
            recognition: 'Recognition',

            dsf: 'Digit Span Forward',
            dsb: 'Digit Span Backward',
            cod: 'Symbol-Digit Challenge',
            vm: 'Memory for Words',
            vismem: 'Where Was What?',
            srt: 'Simple Reaction Time',
            srtaudio: 'Reaction Time with Sound',
            crt: 'Reaction Time with a Twist',
            mst: 'Picture Memory',
            pvt: 'Word Task',
            mat: 'Matrix Test',
            hads: 'Hospital Anxiety and Depression Scale',
            asrs: 'Adult ADHD Self-Report Scale',
            uppsp: 'Impulsive Behavior Scale',
            russug: 'Check-in',
            cobra: 'Cognitive Function Questions',
            audit: 'Alcohol Questions',
            dudit: 'Substance Use Questions',
            pretest: 'Before We Start',
            posttest: 'At the Very End',
            pretestfatigue: 'Before We Start',
            posttestfatigue: 'At the Very End',
            breakpoint: 'Information for Participant',
            matrix: 'Complete the pattern',
            cpt: 'Continuous Performance Test',
            stroop: 'Color Game',
            stroope: 'Color Game Emotional',
            cpfsurvey: 'A Few Short Questions',
            rand36: 'Questions About Your Health',
            addiqol: 'Survey',
            ant: 'Attention Test',
            cptms: 'Continuous Performance Test',
            cpt10: 'Continuous Performance Test',
            pst: 'Memory for Pictures',
            shortpersonalitytest: 'Short Personality Test',
            personalitytest: 'Personality Test',
            grit: 'Perseverance',
            rewardandpunishment: 'Reward and Punishment',
            bwsurvey: 'Questions About Birth Weight',
            birthweightsurvey: 'Questions About Birth Weight',
            fingertappingtest: 'Speed Test',
            cptaudio: 'Listen closely',
            cptaudio7: 'Listen closely',
            rrq: 'Thinking Patterns',
            rrs: 'Thought Scale',
            synsoppfatningBlokk: 'Visual Perception',
            synsoppfatningBlokkMulti: 'Visual Perception',
            synsoppfatningEvent: 'Visual Perception',
            psst: 'PSST',
            ders: 'DERS',
            mrt: 'Mental Rotation',
            survey: 'Survey',
            ptr: 'Pattern Recognition',
            visualPerception: 'What\'s in the Foreground?',
            dotProbe: 'Dot Probe'
        }
    },
    no: {
        message: {
            yes: 'ja',
            no: 'nei',
            hello: 'hei verden',
            instruction: 'Instruksjon',
            practiceAborted: 'Trening avbrutt',
            completed: 'Fullført',
            practice: 'Treningsoppgave',
            test: 'Hovedoppgave',
            continue: 'Fortsett',
            pressContinuePractice: 'Trykk på Fortsett-knappen for å starte treningen.',
            pressContinueTest: 'Trykk på Fortsett-knappen for å starte testen.',
            abort: 'Avbryt oppgave',
            retryTitle: 'En runde til med trening',
            retryText: 'For å sikre at du forstår oppgaven fortsetter treningen med noen flere oppgaver.',
            trainingCompleted: 'Trening fullført!',
            trainingCompletedInfo: 'Trykk på Fortsett-knappen for å starte hovedoppgaven.',
            noFeedback: 'Du får IKKE TILBAKEMELDING når du svarer.',
            feedback: 'Du får tilbakemelding når du svarer.',
            recall: 'Gjenkalling',
            delayed: 'Utsatt gjenkalling',
            recognition: 'Gjenkjenning',

            dsf: 'Tallspenn framlengs',
            dsb: 'Tallspenn baklengs',
            cod: 'Symbol-tall utfordring',
            vm: 'Ord-hukommelse',
            vismem: 'Hvor var hva?',
            srt: 'Enkel reaksjonstid',
            srtaudio: 'Reaksjonstid med lyd',
            crt: 'Reaksjonstid med en vri',
            mst: 'Bildehukommelse',
            pvt: 'Hvilket bilde passer til ordet?',
            mat: 'Matrise Test',
            hads: 'Hospital Anxiety and Depression Scale',
            asrs: 'Adult ADHD Self-Report Scale',
            uppsp: 'Impulsive Behaviour Scale',
            russug: 'Innsjekk',
            cobra: 'Spørsmål om kognitv funksjon',
            audit: 'Spørsmål om alkohol',
            dudit: 'Spørsmål om rusmidler',
            pretest: 'Før vi starter',
            posttest: 'Helt på slutten',
            pretestfatigue: 'Før vi starter',
            posttestfatigue: 'Helt på slutten',
            breakpoint: 'Informasjon til deltaker',
            matrix: 'Finn mønsteret',
            cpt: 'Reaksjonstid med bokstaver',
            stroop: 'Fargelek',
            stroope: 'Fargelek',
            cpfsurvey: 'Noen korte spørsmål',
            rand36: 'Spørsmål om din helse',
            addiqol: 'Spørreundersøkelse',
            ant: 'Pilretning',
            cptms: 'Reaksjonstid med bokstaver',
            cpt10: 'Reaksjonstid med bokstaver',
            pst: 'Like og ulike bilder',
            shortpersonalitytest: 'Kort personlighetstest',
            personalitytest: 'Personlighetstest',
            grit: 'Utholdenhet',
            rewardandpunishment: 'Belønning og straff',
            bwsurvey: 'Spørsmål om fødselsvekt',
            birthweightsurvey: 'Spørsmål om fødselsvekt',
            fingertappingtest: 'Hastighetstest',
            cptaudio: 'Reaksjonstid med lyd',
            cptaudio7: 'Reaksjonstid med lyd',
            rrq: 'Tankemønster',
            rrs: 'Tankeskala',
            synsoppfatningBlokk: 'Synsoppfatning',
            synsoppfatningBlokkMulti: 'Synsoppfatning',
            synsoppfatningEvent: 'Synsoppfatning',
            psst: 'PSST',
            ders: 'DERS',
            mrt: 'Figurlek',
            survey: 'Spørreskjema',
            ptr: 'Mønstergjenkjenning',
            visualPerception: 'What\'s in the Foreground?',
            dotProbe: 'Prikken'
        }
    }
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);




var CIRCULAR_ERROR_MESSAGE = void 0;

function tryStringify(arg) {
    try {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(arg);
    } catch (error) {
        if (!CIRCULAR_ERROR_MESSAGE) {
            try {
                var a = {};
                a.a = a;
                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(a);
            } catch (circular) {
                CIRCULAR_ERROR_MESSAGE = circular.message;
            }
        }
        if (error.message === CIRCULAR_ERROR_MESSAGE) {
            return '[Circular]';
        }
        throw error;
    }
}

function getConstructorName(obj) {
    if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default.a || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default.a) {
        return Object.prototype.toString.call(obj).slice(8, -1);
    }

    while (obj) {
        var descriptor = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(obj, 'constructor');
        if (descriptor !== undefined && typeof descriptor.value === 'function' && descriptor.value.name !== '') {
            return descriptor.value.name;
        }

        obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(obj);
    }

    return '';
}

function format(array) {
    var result = '';
    var index = 0;

    if (array.length > 1 && typeof array[0] === 'string') {
        result = array[0].replace(/(%?)(%([sdjo]))/g, function (match, escaped, ptn, flag) {
            if (!escaped) {
                index += 1;
                var arg = array[index];
                var a = '';
                switch (flag) {
                    case 's':
                        a += arg;
                        break;
                    case 'd':
                        a += +arg;
                        break;
                    case 'j':
                        a = tryStringify(arg);
                        break;
                    case 'o':
                        {
                            var json = tryStringify(arg);
                            if (json[0] !== '{' && json[0] !== '[') {
                                json = '<' + json + '>';
                            }
                            a = getConstructorName(arg) + json;
                            break;
                        }
                }
                return a;
            }
            return match;
        });

        result = result.replace(/%{2,2}/g, '%');

        index += 1;
    }

    if (array.length > index) {
        if (result) result += ' ';
        result += array.slice(index).join(' ');
    }

    return result;
}

function assign() {
    var target = {};
    for (var s = 0; s < arguments.length; s += 1) {
        var source = Object(arguments[s]);
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
}

function getStacktrace() {
    try {
        throw new Error();
    } catch (trace) {
        return trace.stack;
    }
}

var defaults = {
    url: '/logger',
    token: '',
    timeout: 0,
    interval: 100,
    backoff: function backoff(interval) {
        var multiplier = 2;
        var jitter = 0.1;
        var limit = 30000;
        var next = interval * multiplier;
        if (next > limit) next = limit;
        next += next * jitter * Math.random();
        return next;
    },
    capacity: 0,
    trace: ['trace', 'warn', 'error'],
    depth: 0,
    json: false,
    timestamp: function timestamp() {
        return new Date().toISOString();
    }
};

var hasStacktraceSupport = !!getStacktrace();
var isAssigned = false;

function apply(logger, options) {
    if (!logger || !logger.getLogger) {
        throw new TypeError('Argument is not a root loglevel object');
    }

    if (isAssigned) {
        throw new TypeError('You can assign a plugin only one time');
    }

    if (!window || !window.XMLHttpRequest) return logger;

    isAssigned = true;

    options = assign(defaults, options);

    var authorization = 'Bearer ' + options.token;
    var contentType = options.json ? 'application/json' : 'text/plain';

    var isSending = false;
    var isSuspended = false;
    var interval = options.interval;
    var queue = [];
    var sending = { messages: [] };

    function send() {
        if (isSuspended || isSending || !(queue.length || sending.messages.length)) {
            return;
        }

        isSending = true;

        if (!sending.messages.length) {
            sending.messages = queue;
            queue = [];
        }

        if (!sending.content) {
            if (options.json) {
                sending.content = tryStringify({ messages: sending.messages });
            } else {
                var separator = '';
                sending.content = '';
                sending.messages.forEach(function (message) {
                    var stacktrace = message.stacktrace ? '' + message.stacktrace : '';
                    var tmp = message.message.split('>>');
                    if (tmp.length > 1) {
                        message.user = tmp[0];
                        message.message = tmp[1];
                    }
                    sending.content += tryStringify(message) + '\n';
                });
            }
        }

        var xhr = new window.XMLHttpRequest();
        xhr.open('POST', options.url, true);
        xhr.setRequestHeader('Content-Type', contentType);
        if (options.token) {
            xhr.setRequestHeader('Authorization', authorization);
        }

        function suspend(successful) {
            isSuspended = true;

            setTimeout(function () {
                isSuspended = false;
                send();
            }, interval);

            if (!successful) {
                interval = options.backoff(interval);
            }
        }

        var timeout = void 0;
        if (options.timeout) {
            timeout = setTimeout(function () {
                isSending = false;
                xhr.abort();
                suspend();
            }, options.timeout);
        }

        xhr.onreadystatechange = function () {
            if (xhr.readyState !== 4) {
                return;
            }

            isSending = false;
            clearTimeout(timeout);

            if (xhr.status === 200) {
                interval = options.interval;
                sending = { messages: [] };
                suspend(true);
            } else {
                suspend();
            }
        };

        xhr.send(sending.content);
    }

    var originalFactory = logger.methodFactory;
    logger.methodFactory = function methodFactory(methodName, logLevel, loggerName) {
        var rawMethod = originalFactory(methodName, logLevel, loggerName);
        var needStack = hasStacktraceSupport && options.trace.some(function (level) {
            return level === methodName;
        });

        return function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            if (options.capacity && queue.length + sending.messages.length >= options.capacity) {
                if (sending.messages.length) {
                    sending.messages.shift();
                    sending.content = '';
                } else {
                    queue.shift();
                }
            }

            var timestamp = options.timestamp();

            var stacktrace = needStack ? getStacktrace() : '';
            if (stacktrace) {
                var lines = stacktrace.split('\n');
                lines.splice(0, options.depth + 3);
                stacktrace = lines.join('\n');
            }

            queue.push({
                message: format(args),
                level: methodName,
                logger: loggerName,
                timestamp: timestamp,
                stacktrace: stacktrace
            });

            send();

            rawMethod.apply(undefined, args);
        };
    };

    logger.setLevel(logger.getLevel());
    return logger;
}

var remote = { apply: apply };

var save = window ? window.remote : undefined;
remote.noConflict = function () {
    if (window && window.remote === remote) {
        window.remote = save;
    }
    return remote;
};

/* harmony default export */ __webpack_exports__["a"] = (remote);

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    codingKey: ''
};

var mutations = {
    SET_CODINGKEY: function SET_CODINGKEY(state, key) {
        state.codingKey = key;
    }
};

var actions = {
    changeCodingKey: function changeCodingKey(_ref, key) {
        var commit = _ref.commit;

        commit('SET_CODINGKEY', key);
    }
};

var getters = {
    currentCodingKey: function currentCodingKey(state) {
        return state.codingKey;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_logger__ = __webpack_require__(57);


var state = {

    contextState: {
        consent: {
            component: 'Consent',
            consentStatus: false,
            consentTimestamp: '',
            completed: false
        },
        audiocheck: {
            component: 'AudioCheck',
            completed: false
        },
        questions: {
            component: 'Rules',
            answers: '',
            completed: false
        },
        task: {
            component: 'Task',
            completed: false
        },
        done: {
            component: 'Done',
            responses: '',
            completed: false
        },
        feedback: {
            component: 'Feedback',
            feedback: '',
            completed: false
        },
        resultsummary: {
            component: 'Resultsummary',
            feedback: '',
            completed: false
        },
        logout: {
            component: 'Logout',
            completed: false
        },
        currentContext: 'consent'
    }
};

var originalContextState = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(state.contextState));

var mutations = {
    SET_CONSENT: function SET_CONSENT(state, payload) {
        state.contextState.consent.consentStatus = payload.status;
        state.contextState.consent.consentTimestamp = payload.timestamp;
        state.contextState.consent.consentUpload = payload.upload;
        state.contextState.consent.completed = payload.completed;
    },
    SET_AUDIOCHECKCONTEXT: function SET_AUDIOCHECKCONTEXT(state, status) {
        state.contextState.audiocheck.completed = status;
    },
    SET_QUESTIONCONTEXT: function SET_QUESTIONCONTEXT(state, answers) {
        state.contextState.questions.answers = answers;
        state.contextState.questions.completed = true;
    },
    SET_DONECONTEXT: function SET_DONECONTEXT(state, responses) {
        state.contextState.done.responses = responses;
        state.contextState.done.completed = true;
    },
    SET_FEEDBACKCONTEXT: function SET_FEEDBACKCONTEXT(state, feedback) {
        state.contextState.feedback.feedback = feedback;
        state.contextState.feedback.completed = true;
    },
    SET_CURRENTCONTEXT: function SET_CURRENTCONTEXT(state, context) {
        state.contextState.currentContext = context;
    },
    RESET_CONTEXT: function RESET_CONTEXT(state, context) {
        state.contextState[context] = originalContextState[context];
    },
    RESET_ALLCONTEXT: function RESET_ALLCONTEXT(state) {
        state.contextState = originalContextState;
    },
    SET_INITIALCONTEXT: function SET_INITIALCONTEXT(state) {
        state.contextState = '';
    }
};

var actions = {
    updateConsentContext: function updateConsentContext(_ref, status, upload) {
        var commit = _ref.commit,
            state = _ref.state;

        var payload = {
            status: status,
            timestamp: new Date().getTime(),
            upload: upload,
            completed: status
        };
        commit('SET_CONSENT', payload);
    },
    updateAudioCheckContext: function updateAudioCheckContext(_ref2, status) {
        var commit = _ref2.commit,
            state = _ref2.state;

        commit('SET_AUDIOCHECKCONTEXT', status);
    },
    updateQuestionContext: function updateQuestionContext(_ref3, answers) {
        var commit = _ref3.commit,
            state = _ref3.state;

        commit('SET_QUESTIONCONTEXT', answers);
    },
    updateCurrentContext: function updateCurrentContext(_ref4, context) {
        var commit = _ref4.commit,
            state = _ref4.state;

        if (state.contextState.consent.consentStatus && state.contextState.consent.completed) {
            commit('SET_CURRENTCONTEXT', context);
        } else {
            commit('SET_CURRENTCONTEXT', 'consent');
            return 'Cannot change before consent is given.';
        }
    },
    updateDoneContext: function updateDoneContext(_ref5, responses) {
        var commit = _ref5.commit,
            state = _ref5.state;

        commit('SET_DONECONTEXT', responses);
    },
    updateFeedbackContext: function updateFeedbackContext(_ref6, feedback) {
        var commit = _ref6.commit,
            state = _ref6.state;

        commit('SET_FEEDBACKCONTEXT', feedback);
    },
    resetContext: function resetContext(_ref7, context) {
        var commit = _ref7.commit;

        commit('RESET_CONTEXT', context);
    },
    resetAllContext: function resetAllContext(_ref8) {
        var commit = _ref8.commit;

        commit('RESET_ALLCONTEXT');
    },
    setInitialContextState: function setInitialContextState(_ref9) {
        var commit = _ref9.commit;
    },
    logoutAtEnd: function logoutAtEnd(_ref10) {
        var commit = _ref10.commit,
            state = _ref10.state;

        window.dirty = false;
    }
};

var getters = {
    currentContext: function currentContext(state) {
        __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].debug('Getting current context...');
        if (state.contextState.consent.completed && state.contextState.consent.consentStatus) {
            __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].debug('... returning ' + state.contextState.currentContext);
            return state.contextState[state.contextState.currentContext].component;
        } else {
            __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].debug('... no consent.');
            return 'consent';
        }
    },
    consentState: function consentState(state) {
        __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].debug('Getting consent state...');
        return state.contextState.consent;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    currentComponent: 'consent'
};

var mutations = {
    SET_COMPONENT: function SET_COMPONENT(state, target) {
        state.currentComponent = target;
    }
};

var actions = {
    changeTo: function changeTo(_ref, target) {
        var commit = _ref.commit;

        commit('SET_COMPONENT', target);
    }
};

var getters = {
    currentComponent: function currentComponent(state) {
        return state.currentComponent;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_logger__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(73);



__WEBPACK_IMPORTED_MODULE_0__lib_logger__["a" /* default */].debug('Survey.js loaded');

var state = {
    surveyData: {}
};

var mutations = {
    SET_SURVEYDATA: function SET_SURVEYDATA(state, payload) {
        __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set(state.surveyData, payload.id, payload.surveyData);
    }
};

var actions = {
    setSurveyData: function setSurveyData(_ref, payload) {
        var commit = _ref.commit,
            state = _ref.state;

        commit('SET_SURVEYDATA', payload);
    },
    getSurveyDataById: function getSurveyDataById(_ref2, id) {
        var commit = _ref2.commit,
            state = _ref2.state;

        return state.surveyData[id];
    }
};

var getters = {
    getSurveyData: function getSurveyData(state) {
        return state.surveyData;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});

/***/ }),

/***/ 249:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_logger__ = __webpack_require__(57);



__WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].debug('Task.js loaded');

var state = {
    taskStates: [],
    project: { id: 0, project_ref: 'Unknown project' },
    currentTaskIndex: '',
    currentTask: '',
    currentTaskComponent: '',
    currentTaskAudioInstructions: false,
    currentResultId: null,
    userAbortStatus: false
};

var originalTaskState = null;

var mutations = {
    SET_TASKSTATUS: function SET_TASKSTATUS(state, payload) {
        state.taskStates[payload.taskIndex].status = payload.status;
    },
    SET_TASKCOMPONENT: function SET_TASKCOMPONENT(state, payload) {
        __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].debug('SET_TASKCOMPONENT');
        state.taskStates[payload.taskIndex].taskComponent = payload.component;
        state.currentTaskComponent = payload.component;
    },
    SET_PROJECT: function SET_PROJECT(state, payload) {
        __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].debug('SET_PROJECT');
        state.project = payload;
    },
    SET_TASKMETA: function SET_TASKMETA(state, payload) {
        state.taskStates[payload.taskIndex].meta = payload.meta;
    },
    SET_TASKMESSAGE: function SET_TASKMESSAGE(state, payload) {
        state.taskStates[payload.taskIndex].message = payload.message;
    },
    SET_CURRENTTASK: function SET_CURRENTTASK(state, taskIndex) {
        state.currentTaskIndex = taskIndex;
        state.currentTask = state.taskStates[taskIndex].task;
        state.currentTaskComponent = state.taskStates[taskIndex].taskComponent;
    },
    RESET_TASK: function RESET_TASK(state, payload) {
        state.taskStates[payload.taskIndex].taskComponent = 'instruction';
        state.taskStates[payload.taskIndex].meta = '';
        state.taskStates[payload.taskIndex].status = 'clean';
    },
    RESET_ALLTASKS: function RESET_ALLTASKS(state, payload) {
        state.taskStates = originalTaskState;
        state.currentTaskIndex = '';
        state.currentTask = '';
        state.currentTaskComponent = '';
    },
    SET_RESULT_ID: function SET_RESULT_ID(state, resultId) {
        state.currentResultId = resultId;
    },
    SET_TASK: function SET_TASK(state, task) {
        state.currentTask = task;
    },
    SET_TASKSTATE: function SET_TASKSTATE(state, taskStates) {
        __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].info('Setting taskstate %o', taskStates);
        originalTaskState = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(taskStates));
        state.taskStates = taskStates;
    },
    SET_USERABORTSTATUS: function SET_USERABORTSTATUS(state, status) {
        __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].info('Setting abortstatus to ' + status);
        state.userAbortStatus = status;
    }
};

var actions = {
    updateCurrentTaskStatus: function updateCurrentTaskStatus(_ref, status) {
        var commit = _ref.commit,
            state = _ref.state;

        var payload = {
            taskIndex: state.currentTaskIndex,
            status: status
        };
        commit('SET_TASKSTATUS', payload);
        __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].debug(payload);
        if (payload.status === 'completed' || payload.status === 'aborted') {
            for (var i = 0; i < state.taskStates.length; i++) {
                if (state.taskStates[i].status === 'clean' || state.taskStates[i].status === 'started') {
                    commit('SET_CURRENTTASK', i);
                    __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].debug('current task', i);
                    __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].debug('current task state', state.taskStates[i]);
                    break;
                }
            }
        }
    },
    updateCurrentTaskComponent: function updateCurrentTaskComponent(_ref2, component) {
        var commit = _ref2.commit,
            state = _ref2.state;

        __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].info('updateCurrentTaskComponent (taskid: ' + state.currentTaskIndex + '): ' + component);
        var payload = {
            taskIndex: state.currentTaskIndex,
            component: component
        };

        commit('SET_TASKCOMPONENT', payload);
    },
    updateCurrentTaskComponentConnected: function updateCurrentTaskComponentConnected(_ref3, component) {
        var commit = _ref3.commit,
            state = _ref3.state;

        __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].info('updateCurrentTaskComponent (taskid: ' + (state.currentTaskIndex + 1) + '): ' + component);

        var payload = {
            taskIndex: state.currentTaskIndex + 1,
            component: component
        };

        commit('SET_TASKCOMPONENT', payload);
    },
    updateCurrentResultId: function updateCurrentResultId(_ref4, id) {
        var commit = _ref4.commit,
            state = _ref4.state;

        commit('SET_RESULT_ID', id);
    },
    updateCurrentTaskMeta: function updateCurrentTaskMeta(_ref5, meta) {
        var commit = _ref5.commit,
            state = _ref5.state;

        var payload = {
            taskIndex: state.currentTaskIndex,
            meta: meta
        };
        commit('SET_TASKMETA', payload);
    },
    updateCurrentTaskMessage: function updateCurrentTaskMessage(_ref6, message) {
        var commit = _ref6.commit,
            state = _ref6.state;

        var payload = {
            taskIndex: state.currentTaskIndex,
            message: message
        };
        commit('SET_TASKMESSAGE', payload);
    },
    resetCurrentTask: function resetCurrentTask(_ref7) {
        var commit = _ref7.commit,
            state = _ref7.state;

        var payload = {
            taskIndex: state.currentTaskIndex
        };
        commit('SET_RESETTASK', payload);
    },

    updateTaskStatus: function updateTaskStatus(_ref8, task, status) {
        var commit = _ref8.commit,
            state = _ref8.state;

        var payload = {
            taskIndex: task,
            status: status
        };
        commit('SET_TASKSTATUS', payload);
    },
    updateTaskComponent: function updateTaskComponent(_ref9, task, component) {
        var commit = _ref9.commit,
            state = _ref9.state;

        __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].info('updateTaskComponent (taskid: ' + task + '): ' + component);
        var payload = {
            taskIndex: task,
            component: component
        };
        commit('SET_TASKCOMPONENT', payload);
    },
    updateTaskMeta: function updateTaskMeta(_ref10, task, meta) {
        var commit = _ref10.commit,
            state = _ref10.state;

        var payload = {
            taskIndex: task,
            meta: meta
        };
        commit('SET_TASKMETA', payload);
    },
    resetTask: function resetTask(_ref11, task) {
        var commit = _ref11.commit,
            state = _ref11.state;

        var payload = {
            taskIndex: task
        };
        commit('SET_RESETTASK', payload);
    },
    resetAllTasks: function resetAllTasks(_ref12) {
        var commit = _ref12.commit,
            state = _ref12.state;

        commit('SET_RESETALLTASKS');
    },

    changeTask: function changeTask(_ref13, task) {
        var commit = _ref13.commit;

        commit('SET_TASK', task);
    },
    setProject: function setProject(_ref14, project) {
        var commit = _ref14.commit;

        commit('SET_PROJECT', project);
    },
    changeTaskComponent: function changeTaskComponent(_ref15, component) {
        var commit = _ref15.commit;

        commit('SET_TASKCOMPONENT', component);
    },
    userAbortStatus: function userAbortStatus(_ref16, status) {
        var commit = _ref16.commit;

        commit('SET_USERABORTSTATUS', status);
    }
};

var getters = {
    currentTask: function currentTask(state) {
        __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].debug('Getting current task...');
        for (var i = 0; i < state.taskStates.length; i++) {
            __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].debug('Task: ' + state.taskStates[i].task + ' - ' + state.taskStates[i].status);
            if (state.taskStates[i].status === 'clean' || state.taskStates[i].status === 'started') {
                __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].info('Returning "' + state.taskStates[i].task + '" as current task');
                state.currentTask = state.taskStates[i].task;
                state.currentTaskIndex = i;
                state.currentTaskAudioInstructions = state.taskStates[i].config.audioInstructions;
                return state.taskStates[i].task;
            }
        }
        return 'ERROR: Could not get current task!';
    },
    currentTaskState: function currentTaskState(state) {
        __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].debug('Getting current task state...');
        return state.taskStates[state.currentTaskIndex];
    },
    currentProject: function currentProject(state) {
        __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].debug('Getting current project state...');
        return state.project;
    },
    currentTaskMessage: function currentTaskMessage(state) {
        for (var i = 0; i < state.taskStates.length; i++) {
            if (state.taskStates[i].status === 'clean' || state.taskStates[i].status === 'started') {
                return state.taskStates[i].message;
            }
        }
        return 'ERROR: Could not get message!';
    },
    currentTaskComponent: function currentTaskComponent(state) {
        __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].debug('Getting current task component...');
        for (var i = 0; i < state.taskStates.length; i++) {
            if (state.taskStates[i].status === 'clean' || state.taskStates[i].status === 'started') {
                __WEBPACK_IMPORTED_MODULE_1__lib_logger__["a" /* default */].info('Returning "' + state.taskStates[i].taskComponent + '" as current task component');
                state.currentTaskComponent = state.taskStates[i].taskComponent;
                return state.taskStates[i].taskComponent;
            }
        }
        return 'ERROR: Could not get current task component!';
    },
    nTasksCompleted: function nTasksCompleted(state) {
        for (var i = 0; i < state.taskStates.length; i++) {
            if (state.taskStates[i].status === 'clean' || state.taskStates[i].status === 'started') {
                return i;
            }
        }
        return 'ERROR: Could not get current task completion number!';
    },
    nTasks: function nTasks(state) {
        return state.taskStates.length - 1;
    },
    currentResultId: function currentResultId(state) {
        return state.currentResultId;
    },
    getUserAbortStatus: function getUserAbortStatus(state) {
        return state.userAbortStatus;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});

/***/ }),

/***/ 250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    initialPositions: ''
};

var mutations = {
    SET_VISMEMPOSITIONS: function SET_VISMEMPOSITIONS(state, pos) {
        state.initialPositions = pos;
    }
};

var actions = {
    changeVismemPositions: function changeVismemPositions(_ref, pos) {
        var commit = _ref.commit;

        commit('SET_VISMEMPOSITIONS', pos);
    }
};

var getters = {
    currentVismemPositions: function currentVismemPositions(state) {
        return state.initialPositions;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
    wordList: ''
};

var mutations = {
    SET_WORDLISTS: function SET_WORDLISTS(state, wordList) {
        state.wordList = wordList;
    }
};

var actions = {
    setvmWordList: function setvmWordList(_ref, wordList) {
        var commit = _ref.commit;

        commit('SET_WORDLISTS', wordList);
    }
};

var getters = {
    vmMainWordList: function vmMainWordList(state) {
        return state.wordList.main_list;
    },
    vmDistractionWordList: function vmDistractionWordList(state) {
        return state.wordList.distraction_list;
    },
    vmRecognitionWordList: function vmRecognitionWordList(state) {
        return state.wordList.recognition_list;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
});

/***/ }),

/***/ 252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_dashboard__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_context__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_task__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_coding__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_vismem__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_vm__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_survey__ = __webpack_require__(248);












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
    state: {
        user: {
            consent_given_at: null,
            userId: null,
            wants_result_summary: null,
            result_summary: null,
            urt: null
        },
        project: {
            id: null,
            project_ref: null,
            consent_text: null,
            link_login: null,
            pdf: false
        }
    },
    modules: {
        dashboard: __WEBPACK_IMPORTED_MODULE_2__modules_dashboard__["a" /* default */],
        context: __WEBPACK_IMPORTED_MODULE_3__modules_context__["a" /* default */],
        task: __WEBPACK_IMPORTED_MODULE_4__modules_task__["a" /* default */],
        coding: __WEBPACK_IMPORTED_MODULE_5__modules_coding__["a" /* default */],
        vismem: __WEBPACK_IMPORTED_MODULE_6__modules_vismem__["a" /* default */],
        vm: __WEBPACK_IMPORTED_MODULE_7__modules_vm__["a" /* default */],
        survey: __WEBPACK_IMPORTED_MODULE_8__modules_survey__["a" /* default */]
    },
    actions: {
        setProject: function setProject(_ref, payload) {
            var commit = _ref.commit;

            commit('SET_PROJECT', payload);
        },
        setUser: function setUser(_ref2, payload) {
            var commit = _ref2.commit;

            commit('SET_USER', payload);
        },
        setUserUrt: function setUserUrt(_ref3) {
            var commit = _ref3.commit;

            commit('SET_USER_URT');
        },
        clearState: function clearState(_ref4, payload) {
            var commit = _ref4.commit;

            commit('CLEAR_STATE');
        }
    },
    getters: {
        getUserId: function getUserId(state) {
            return state.user.userId;
        },
        getProject: function getProject(state) {
            return state.project;
        },
        getResultSummary: function getResultSummary(state) {
            return state.user.result_summary;
        }
    },
    mutations: {
        SET_USER: function SET_USER(state, user) {
            state.user = user;
        },
        SET_PROJECT: function SET_PROJECT(state, project) {
            state.project = project;
        },
        SET_USER_URT: function SET_USER_URT(state) {
            state.user.urt = true;
        },
        CLEAR_STATE: function CLEAR_STATE(state) {
            state.user = {
                consent_given_at: null,
                userId: null,
                wants_result_summary: null,
                result_summary: null,
                urt: null
            };
            state.dashboard = {
                currentComponent: 'consent'
            };
            state.context = {
                contextState: {
                    consent: {
                        component: 'Consent',
                        consentStatus: false,
                        consentTimestamp: '',
                        completed: false
                    },
                    audiocheck: {
                        component: 'AudioCheck',
                        completed: false
                    },
                    questions: {
                        component: 'Rules',
                        answers: '',
                        completed: false
                    },
                    task: {
                        component: 'Task',
                        completed: false
                    },
                    done: {
                        component: 'Done',
                        responses: '',
                        completed: false
                    },
                    feedback: {
                        component: 'Feedback',
                        feedback: '',
                        completed: false
                    },
                    resultsummary: {
                        component: 'Resultsummary',
                        feedback: '',
                        completed: false
                    },
                    logout: {
                        component: 'Logout',
                        completed: false
                    },
                    currentContext: 'consent'
                }
            };
            state.task = {
                taskStates: [],
                currentTaskIndex: '',
                currentTask: '',
                currentTaskComponent: '',
                currentResultId: null,
                userAbortStatus: false
            };
            state.coding = {
                codingKey: ''
            };
            state.vismem = {
                initialPositions: ''
            };
            state.vm = {
                wordList: ''
            };
        }
    }
}));

/***/ }),

/***/ 253:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);



var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.name && this.$children.length === 0) {
      console.warn('Invalid prop: prop "name" is required.');
      return;
    }

    if (this.icon) {
      return;
    }

    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;

      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ 254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_logger__ = __webpack_require__(57);






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    data: function data() {
        return {
            development: false,
            showbtns: false
        };
    },

    methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])({
        changeTask: 'changeTask',
        changeComponent: 'changeTaskComponent',
        updateTask: 'updateTask',
        updateCurrentContext: 'updateCurrentContext',
        updateCurrentTaskStatus: 'updateCurrentTaskStatus',
        updateCurrentTaskComponent: 'updateCurrentTaskComponent',
        updateCurrentTaskComponentConnected: 'updateCurrentTaskComponentConnected'
    }), {
        changeTaskComponent: function changeTaskComponent(component) {
            this.changeComponent(component);
        }
    }),
    created: function created() {
        __WEBPACK_IMPORTED_MODULE_2__lib_logger__["a" /* default */].info('[Memoro] - Welcome to Memoro!');
    }
});

/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_custom_howler__ = __webpack_require__(213);



/* harmony default export */ __webpack_exports__["default"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_custom_howler__["a" /* default */]],
    props: ['icon', 'myname']
});

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(493)

var Component = __webpack_require__(94)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(517),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 493:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(494)

var Component = __webpack_require__(94)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(518),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 517:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.klass,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path, i) {
    return _c('path', _vm._b({
      key: ("path-" + i)
    }, 'path', path, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon, i) {
    return _c('polygon', _vm._b({
      key: ("polygon-" + i)
    }, 'polygon', polygon, false))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 518:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), (_vm.development) ? _c('div', [(!_vm.showbtns) ? _c('button', {
    staticStyle: {
      "position": "absolute",
      "bottom": "0px",
      "left": "0px"
    },
    on: {
      "click": function($event) {
        _vm.showbtns = true
      }
    }
  }, [_vm._v("Show devtools")]) : _vm._e(), _vm._v(" "), (_vm.showbtns) ? _c('div', [_c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "well"
  }, [(_vm.showbtns) ? _c('button', {
    staticClass: "pull-right",
    on: {
      "click": function($event) {
        _vm.showbtns = false
      }
    }
  }, [_vm._v("Hide")]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Development tools")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', [_vm._v("Task state:")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskStatus('clean')
      }
    }
  }, [_vm._v("Clean")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskStatus('started')
      }
    }
  }, [_vm._v("Started")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskStatus('completed')
      }
    }
  }, [_vm._v("Complete")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskStatus('aborted')
      }
    }
  }, [_vm._v("Aborted")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', [_vm._v("Context state")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentContext('done')
      }
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentContext('consent')
      }
    }
  }, [_vm._v("Consent")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentContext('task')
      }
    }
  }, [_vm._v("Task")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentContext('feedback')
      }
    }
  }, [_vm._v("Feedback")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h5', [_vm._v("Task part")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskComponent('instruction')
      }
    }
  }, [_vm._v("Instruction")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskComponent('training')
      }
    }
  }, [_vm._v("Training")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskComponent('trainingcompleted')
      }
    }
  }, [_vm._v("\n                        Training Completed\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskComponent('test')
      }
    }
  }, [_vm._v("Test")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskComponent('recall')
      }
    }
  }, [_vm._v("Recall")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskComponent('delayed')
      }
    }
  }, [_vm._v("Delayed")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskComponent('recognition')
      }
    }
  }, [_vm._v("Recognition")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.updateCurrentTaskComponent('testcompleted')
      }
    }
  }, [_vm._v("Test Completed")])])])]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 519:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(200);
module.exports = __webpack_require__(136);


/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_loglevel__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_loglevel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_loglevel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__loglevel_custom_remote__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loglevel_plugin_prefix__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_loglevel_plugin_prefix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_loglevel_plugin_prefix__);




var defaults = {
    url: 'https://hippocampus.medisin.ntnu.no/api/memorolog.php',
    timeout: 0,
    interval: 100,
    backoff: function backoff(interval) {
        var multiplier = 2;
        var jitter = 0.1;
        var limit = 30000;
        var next = interval * multiplier;
        if (next > limit) next = limit;
        next += next * jitter * Math.random();
        return next;
    },
    capacity: 0,
    trace: ['trace', 'warn', 'error'],
    depth: 0,
    json: false,
    timestamp: function timestamp() {
        return new Date().toISOString();
    }
};

var prefixDefaults = {
    template: '[%t]:',
    timestampFormatter: function timestampFormatter(date) {
        return date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1');
    },
    levelFormatter: function levelFormatter(level) {
        return level.toUpperCase();
    },
    nameFormatter: function nameFormatter(name) {
        return name || 'root';
    }
};

if (false) {
    log.setLevel('TRACE', true);
    log.enableAll();
} else {
    __WEBPACK_IMPORTED_MODULE_1__loglevel_custom_remote__["a" /* default */].apply(__WEBPACK_IMPORTED_MODULE_0_loglevel__, defaults);
    __WEBPACK_IMPORTED_MODULE_2_loglevel_plugin_prefix___default.a.apply(__WEBPACK_IMPORTED_MODULE_0_loglevel__, prefixDefaults);
    __WEBPACK_IMPORTED_MODULE_0_loglevel__["setLevel"]('ERROR', true);
}
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_loglevel__);

/***/ })

},[524]);


// WEBPACK FOOTER //
// static/js/app.668e2afe18260bcd300c.js